<template>
  <div>
    <div :style="cartButtonStyle" @click="showShoppingCart" v-if="isShoppingButtonVisible"
         :class="cartButtonClass" class="cart-button">
      <em class="fa fa-money-bill-wave" :style="iconTextStyle"/>
    </div>
    <cart-popup-block v-if="isShoppingCartVisible" @close="closeShoppingCart"
                      :cart-breakdown-props="cartBreakdownProps"
                      :status="status"/>
  </div>
</template>

<script>
import Block from './Block.vue';
import CartPopupBlock from './CartPopupBlock.vue';

import { TextProps } from '../models';

export default {
  name: 'cart-block',
  extends: Block,
  components: { CartPopupBlock },
  props: {
    blockProps: { type: Object, default: () => null },
    iconTextProps: { type: Object, default: () => null },
    cartBreakdownProps: { type: Object, default: () => null },
  },
  mounted() {
    this.$parent.$parent.$el.classList.add('cart-button-container');
    if (this.status) {
      this.isShoppingCartVisible = true;
    } else {
      this.startTimerhideButtonCart();
    }
  },
  computed: {
    isShoppingButtonVisible() {
      return !!this.$route.query.saleLocation;
    },
    cartButtonStyle() {
      return this.myBlockProps.getStyles();
    },
    iconTextStyle() {
      const iconTextProperties = new TextProps(this.iconTextProps);
      return iconTextProperties.getStyles();
    },
    status() {
      return this.$store.getters.status;
    },
    cartButtonClass() {
      return { 'button-show': !this.cartButtonHidden, 'button-hidden': this.cartButtonHidden };
    }
  },
  watch: {},
  data() {
    return {
      isShoppingCartVisible: false,
      cartButtonHidden: false,
      cartButtonHiddenTimer: null
    };
  },
  methods: {
    showShoppingCart() {
      if (!this.cartButtonHidden) {
        this.clearTimerhideButtonCart();
        this.isShoppingCartVisible = true;
      } else {
        this.clearTimerhideButtonCart();
        this.showButtonCart();
        this.startTimerhideButtonCart();
      }
    },
    closeShoppingCart() {
      this.clearTimerhideButtonCart();
      this.showButtonCart();
      this.isShoppingCartVisible = false;
      this.startTimerhideButtonCart();
    },
    startTimerhideButtonCart() {
      this.cartButtonHiddenTimer = setTimeout(this.hideButtonCart, 3000);
    },
    clearTimerhideButtonCart() {
      clearTimeout(this.cartButtonHiddenTimer);
    },
    hideButtonCart() {
      this.cartButtonHidden = true;
      this.$parent.$parent.$el.classList.add('cart-button-container-hidden');
    },
    showButtonCart() {
      this.cartButtonHidden = false;
      this.$parent.$parent.$el.classList.remove('cart-button-container-hidden');
    }
  }
};
</script>

<style lang="scss">
.cart-button {
  transition: 0.5s ease-out;
}

.cart-button-container {
  transition: 0.5s ease-out;
}

.cart-button-container-hidden {
  transition: 0.3s ease-in;
  right: 0 !important;
}

.button-hidden {
  transition: 0.5s ease-in;
  transform: translateX(80%);
}
</style>
